import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22login-screen.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../app/fonts/TumblyBold.otf%22,%22weight%22:%22700%22,%22display%22:%22swap%22}],%22variableName%22:%22brandFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'brandFont', 'brandFont Fallback'",
        fontWeight: 700,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
